<ion-header class="vh-header">
  <ion-toolbar>
    <div class="vh-titlebar">
      <div class="vh-title-group">
        <h2 class="vh-title">{{ 'Version history' | translate }}</h2>
        <span class="vh-field-chip" *ngIf="fieldLabel">{{ fieldLabel }}</span>
      </div>
      <button type="button" class="vh-close" (click)="close()" [attr.aria-label]="'Close' | translate">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="vh-content">
  <div class="vh-body">
    <!-- Timeline: every version, newest first -->
    <nav class="vh-timeline" [attr.aria-label]="'Version history' | translate">
      <button
        type="button"
        class="vh-node"
        *ngFor="let i of orderedIndices"
        [class.is-selected]="i === selectedIndex"
        [attr.aria-current]="i === selectedIndex ? 'true' : null"
        (click)="select(i)"
      >
        <span class="vh-node-marker" aria-hidden="true">
          <span class="vh-chip" [class.is-current]="isCurrent(i)">{{ versionLabel(i) }}</span>
        </span>
        <span class="vh-node-body">
          <span class="vh-node-top">
            <span class="vh-node-action">{{ actionLabel(entries[i]) | translate }}</span>
            <span class="vh-node-current" *ngIf="isCurrent(i)">{{ 'In use now' | translate }}</span>
          </span>
          <span class="vh-node-time">
            <ng-container *ngIf="entries[i].action !== 'original'">{{ relativeTime(entries[i].at) }}</ng-container>
            <ng-container *ngIf="entries[i].action === 'original'">{{ 'Starting text' | translate }}</ng-container>
          </span>
        </span>
      </button>
    </nav>

    <!-- Reading panel: the selected version, in full -->
    <section class="vh-detail" *ngIf="selectedEntry as entry">
      <header class="vh-detail-head">
        <h3 class="vh-detail-title">{{ actionLabel(entry) | translate }}</h3>
        <span class="vh-detail-time">
          <ng-container *ngIf="entry.action !== 'original'">{{ relativeTime(entry.at) }}</ng-container>
          <ng-container *ngIf="entry.action === 'original'">{{ 'The text you started with' | translate }}</ng-container>
        </span>
      </header>

      <p class="vh-prompt" *ngIf="entry.prompt">
        <span class="vh-prompt-label">{{ promptLabel(entry) | translate }}</span>
        {{ entry.prompt }}
      </p>

      <div class="vh-textcard">
        <p class="vh-text" *ngIf="entry.text; else emptyText">{{ entry.text }}</p>
        <ng-template #emptyText>
          <span class="vh-empty">{{ '(empty)' | translate }}</span>
        </ng-template>
      </div>

      <div class="vh-detail-action">
        <span class="vh-inuse" *ngIf="isSelectedCurrent">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
          {{ 'This is the version in use now' | translate }}
        </span>
        <button type="button" class="vh-use" *ngIf="!isSelectedCurrent" (click)="useThisVersion()">
          {{ 'Use this version' | translate }}
        </button>
      </div>
    </section>
  </div>
</ion-content>
